/*工资发放明细 */
import { $http, buildHeaders } from "./index";

//获取工资表明细
export const payrollemployee_list = (params) => {
  return $http.get("/admin/PayrollEmployee/index", { params });
};

//根据客户Id获取到款记录
export const payrollemployee_bankreceived = (params) => {
  return $http.get("/admin/PayrollEmployee/bankReceived", { params });
};

//下载工资表模板
export const payrollemployee_download = (payroll_id) => {
  return $http.get("/admin/PayrollEmployee/downloadTemplate", {
    params: { payroll_id },
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//修改员工工资表信息
export const payrollemployee_save = (data) => {
  return $http.post("/admin/PayrollEmployee/save", data, {
    headers: buildHeaders(3),
  });
};

//批量编辑员工工资表信息
export const payrollemployee_editbatch = (payroll_id, data) => {
  return $http.post(
    "/admin/PayrollEmployee/editBatch",
    { payroll_id, data: JSON.stringify(data) },
    {
      headers: buildHeaders(3),
    }
  );
};

//提交算税
export const payrollemployee_applycalctax = (data) => {
  return $http.post("/admin/PayrollEmployee/applyCalcTax", data, {
    headers: buildHeaders(3),
  });
};

//取消算税
export const payrollemployee_cancelcalctax = (data) => {
  return $http.post("/admin/PayrollEmployee/cancelCalcTax", data, {
    headers: buildHeaders(3),
  });
};

//导入工资表
export const payrollemployee_import = (data) => {
  let headers = buildHeaders(1, "工资表数据解析中，请稍后……");
  headers["Content-Type"] = "multipart/form-data";
  return $http.post("/admin/PayrollEmployee/import", data, {
    headers,
  });
};

//从工资表中删除员工记录
export const payrollemployee_delete = (data) => {
  return $http.post("/admin/PayrollEmployee/del", data, {
    headers: buildHeaders(3),
  });
};

//从工资表中删除员工记录
export const payrollemployee_declare = (id) => {
  return $http.post(
    "/admin/PayrollEmployee/employeeDeclare",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取算税数量
export const payrollemployee_getcount_tax = (params) => {
  return $http.get("/admin/PayrollEmployee/calcTaxNum", {
    params,
  });
};

//获取发薪数量
export const payrollemployee_getcount_pay = (params) => {
  return $http.get("/admin/PayrollEmployee/salaryNum", {
    params,
  });
};
//获取异常数量
export const payrollemployee_getcount_error = (payroll_id) => {
  return $http.get("/admin/PayrollEmployee/importExceptionNum", {
    params: { payroll_id },
  });
};

//批量获取员工
export const payrollemployee_getbyid = (params) => {
  return $http.get("/admin/PayrollEmployee/infoBatch", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//根据工资表Id获取异常记录
export const payrollemployee_error_get = (payroll_id) => {
  return $http.get("/admin/PayrollEmployee/importException", {
    params: { payroll_id },
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//选择扣缴义务人触发校验异常
export const payrollemployee_error_judge = (params) => {
  return $http.get("/admin/PayrollEmployee/checkImportException", {
    params,
    headers: buildHeaders(3, "正在校验数据，请稍后……"),
  });
};

//异常提交
export const payrollemployee_error_submit = (data) => {
  return $http.post("/admin/PayrollEmployee/dealImportException", data, {
    headers: buildHeaders(3),
  });
};

//导出异常信息
export const payrollemployee_error_export = (data) => {
  return $http.get("/admin/PayrollEmployee/exportImportException", {
    params: data,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//获取申请发薪对象
export const payrollemployee_pay_detail = (params) => {
  return $http.get("/admin/PayrollEmployee/getApplySalary", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//提交发薪申请
export const payrollemployee_pay_submit = (data) => {
  return $http.post("/admin/PayrollEmployee/applySalary", data, {
    headers: buildHeaders(3),
  });
};

//批量设置扣缴义务人
export const payrollemployee_setwithholdingagent = (data) => {
  return $http.post("/admin/PayrollEmployee/editWithholdingAgentBatch", data, {
    headers: buildHeaders(3),
  });
};

//导出工资表
export const payrollemployee_export = (params) => {
  return $http.get("/admin/PayrollEmployee/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
